import { Base } from "../../framework/base";
import { FileAttachment } from "../common/fileAttachment";
import { EnumHelper, InstantMessageReadState } from "../enums";
import { Translations } from "../translations";
import { ModifyUser } from "../user/modifyUser";
var InstantMessageListItem = /** @class */ (function () {
    function InstantMessageListItem(obj) {
        this.id = obj && obj.id || "";
        this.channelId = obj && obj.channelId || "";
        this.content = obj && obj.content || "";
        this.readState = obj && obj.readState || InstantMessageReadState.NotRead;
        this.rowId = obj && obj.rowId || "";
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        this.deleteUser = obj && obj.deleteUser ? new ModifyUser(obj.deleteUser) : null;
        this.attachments = Base.getTypedArray(obj ? obj.attachments : null, FileAttachment);
        this.replyToInstantMessage = null;
        if (obj && obj.replyToInstantMessage) {
            this.replyToInstantMessage = new InstantMessageListItem(obj.replyToInstantMessage);
        }
        this.isTitle = obj && obj.isTitle || false;
    }
    InstantMessageListItem.prototype.isNew = function () {
        return !this.rowId;
    };
    InstantMessageListItem.prototype.isDeleted = function () {
        return !!this.deleteUser;
    };
    InstantMessageListItem.prototype.isNotRead = function () {
        return EnumHelper.isEqual(this.readState, InstantMessageReadState.NotRead);
    };
    InstantMessageListItem.prototype.isSomeRead = function () {
        return EnumHelper.isEqual(this.readState, InstantMessageReadState.SomeRead);
    };
    InstantMessageListItem.prototype.isAllRead = function () {
        return EnumHelper.isEqual(this.readState, InstantMessageReadState.AllRead);
    };
    InstantMessageListItem.prototype.isUserRead = function () {
        return EnumHelper.isEqual(this.readState, InstantMessageReadState.UserRead);
    };
    InstantMessageListItem.prototype.getHash = function () {
        return this.id + "#" + this.rowId;
    };
    InstantMessageListItem.prototype.getText = function (userCode) {
        return this.isDeleted()
            ? (this.deleteUser.code === userCode
                ? Translations.YouDeletedThisMessage
                : (this.modifyUser.code === this.deleteUser.code
                    ? Translations.ThisMessageWasDeleted
                    : String.format(Translations.ThisMessageWasDeletedByInstantMessageChannelAdministrator, this.deleteUser.name)))
            : this.content;
    };
    InstantMessageListItem.sortInstantMessageListItems = function (items, column, asc) {
        if (!items && items.length < 2)
            return items;
        return items.sort(function (a, b) { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.modifyUser.date, b.modifyUser.date)); });
    };
    InstantMessageListItem.createTitleItem = function (title) {
        var result = new InstantMessageListItem();
        result.id = Base.getGuid();
        result.isTitle = true;
        result.content = title;
        return result;
    };
    return InstantMessageListItem;
}());
export { InstantMessageListItem };
